module.exports = __webpack_public_path__ + "static/media/rijksuniversiteit_groningen.7ef3c1dc.png";